import { UnumApplicantDto, UnumDocumentDto } from 'enrollment/queries';
import {
  UnumApplicationRequestDto,
  UnumApplicationSurveyResponsesDto,
  UnumSubBeneficiaryResponseDto,
} from '../types';
import { BeneficiariesDto } from 'enrollment/queries/useEnrollmentAddBeneficiaryQuery/types';

export const unumBaseValidation = (unumData: { [key: string]: any }): any => {
  const application = unumData['ApplicantType'] as {
    [key: number]: string | number;
  };
  const errorValidation: boolean[] = [];
  Object.keys(application).forEach((key, index) => {
    let identifier = application[Number(key)];
    if (identifier === 'Child') {
      identifier += unumData.DependentID[index];
    }

    if (!unumData[`CoveragePlanID${identifier}`]) {
      errorValidation.push(true);
    } else {
      errorValidation.push(false);
    }
  });
  return errorValidation;
};

export const formUnpacking = (obj: any, path: string, value: any): any => {
  const keys = path
    .replace(/\]/g, '')
    .split('[')
    .filter((key) => key !== '');
  keys.reduce((acc, key, index) => {
    if (index === keys.length - 1) {
      acc[key] = value;
    } else {
      acc[key] = acc[key] || {};
    }
    return acc[key];
  }, obj);
  return obj;
};

export const isHiddenDocument = (
  surveyResponses: UnumApplicationSurveyResponsesDto,
  surveyQuestions: UnumApplicantDto[],
  document: UnumDocumentDto
) => {
  if (!document.RelatedQuestionTrigger) {
    return false;
  }

  const applicants = surveyQuestions.find((applicant) =>
    applicant.ProductQuestions.StateApplicationQuestion.find(
      (question) => question.QuestionType === document.RelatedQuestionType
    )
  );
  const question = applicants?.ProductQuestions.StateApplicationQuestion.find(
    (question) => question.QuestionType === document.RelatedQuestionType
  );

  if (!question) {
    return false;
  }

  if (
    surveyResponses.questions[question.QuestionID] ===
    document.RelatedQuestionTrigger
  ) {
    return false;
  } else {
    return true;
  }
};

export const formatApplicationQuestionPayload = (
  responses: UnumApplicationSurveyResponsesDto,
  payload: UnumApplicationRequestDto
) => {
  payload.unum = { ...payload.unum, ...responses };
};

export const formatApplicationDocumentsPayload = (
  documentResponses: UnumApplicationRequestDto,
  payload: UnumApplicationRequestDto
) => {
  payload.unum = { ...payload.unum, ...documentResponses };
};

export const formatApplicationBeneficiariesPayload = (
  beneficiaryResponses: { [key: string]: BeneficiariesDto[] }[],
  payload: UnumApplicationRequestDto
) => {
  let mapped: {
    [key: string]: {
      Beneficiaries: { [key: string]: UnumSubBeneficiaryResponseDto };
      DependentID: string;
      ApplicantType: string;
    };
  } = {};

  beneficiaryResponses.forEach((beneficiaries, benIndex) => {
    beneficiaries.beneficiaries.forEach((beneficiary, index) => {
      const nameSplit = beneficiary.name.split(' ', 2);
      const nestedData: UnumSubBeneficiaryResponseDto = {
        FirstName: nameSplit[0],
        LastName: nameSplit[1] || '',
        RelationType: beneficiary.relationship,
        SplitPercent: beneficiary.allocation,
        Ranking: beneficiary.primary_beneficiary ? 'Primary' : 'Contingent',
      };

      mapped = {
        ...mapped,
        [String(benIndex)]: {
          Beneficiaries: {
            [String(index)]: nestedData,
          },
          DependentID: String(beneficiaries.orgBenefitId),
          ApplicantType: String(beneficiaries.orgBenefitName),
        },
      };
    });
  });
  const formattedBeneficiaryData: {
    beneficiaries: {
      [key: string]: {
        [key: string]:
          | { [key: string]: UnumSubBeneficiaryResponseDto }
          | string;
      };
    };
  } = {
    beneficiaries: mapped,
  };

  payload.unum = { ...payload.unum, ...formattedBeneficiaryData };
};

export const formatHeightQuestionPayload = (
  responses: UnumApplicationSurveyResponsesDto,
  payload: UnumApplicationRequestDto,
  surveyQuestions: UnumApplicantDto[]
) => {
  surveyQuestions.forEach((applicant) => {
    const questions = applicant.ProductQuestions.StateApplicationQuestion;
    questions.forEach((question) => {
      if (question.QuestionAnswerType === 'Height') {
        const height = responses.questions[question.QuestionID] as string;
        const feet = height.split('-')[0];
        const inches = height.split('-')[1];
        if (inches && feet) {
          payload[`unum_questions_${question.QuestionID}_feet`] = feet;
          payload[`unum_questions_${question.QuestionID}_inches`] = inches;
        }
      }
    });
  });
};

export const formatApplicationOptionsPayload = (
  hasErrors: string,
  optionIndex: number,
  payload: UnumApplicationRequestDto
) => {
  if (hasErrors !== '') {
    payload['err_option'] = optionIndex;
  }
};

export const formatApplicationSignedPayload = (
  signatureSigned: string | undefined,
  payload: UnumApplicationRequestDto
) => {
  if (signatureSigned !== undefined) {
    payload['unum_sign'] = 'Sign';
  }
};
